import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';
import { isDestinationCountry } from 'utils/countries';

export const spouseValidationSchema = Yup.object({
    birth_date: validateField(ValidationType.STRING),
    country_of_residence: validateField(ValidationType.STRING),
    firstname: validateField(ValidationType.STRING),
    lastname: validateField(ValidationType.STRING),
    middlename: validateField(ValidationType.STRING, false),
    gender: validateField(ValidationType.STRING, false).oneOf(
        ['Male', 'Female', ''],
        'Please select a gender'
    ),
    nationality: validateField(ValidationType.STRING),
    region_of_residence: Yup.string()
        .nullable()
        .when('country_of_residence', {
            is: isDestinationCountry,
            then: (schema) => schema.required('Region is required'),
            otherwise: (schema) => schema.nullable(),
        }),
    residency_status: Yup.string()
        .nullable()
        .when('country_of_residence', {
            is: isDestinationCountry,
            then: (schema) => schema.required('Residency status is required'),
            otherwise: (schema) => schema.nullable(),
        }),
    residence_since: validateField(ValidationType.STRING, false),
    income: validateField(ValidationType.INTEGER, false),
});
